import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ApplyLinkQueryVariables = Types.Exact<{
  input: Types.Scalars['ID']['input'];
  mobvjtk: Types.Scalars['String']['input'];
  continueUrl: Types.Scalars['String']['input'];
  spn?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  clientMeta: Types.Scalars['String']['input'];
  source: Types.Scalars['String']['input'];
}>;


export type ApplyLinkQuery = { __typename?: 'Query', jobData: { __typename?: 'JobDataPayload', results: Array<{ __typename?: 'JobDataResult', job: { __typename?: 'Job', key: string, indeedApply: { __typename?: 'JobIndeedApplyAttributes', applyLink?: { __typename?: 'ApplyLink', url: string } | null } } }> } };


export const ApplyLinkDocument = gql`
    query ApplyLink($input: ID!, $mobvjtk: String!, $continueUrl: String!, $spn: Boolean, $clientMeta: String!, $source: String!) {
  jobData(jobKeys: [$input]) {
    results {
      job {
        key
        indeedApply {
          applyLink(
            property: INDEED
            trackingKeys: {mobvjtk: $mobvjtk}
            continueUrl: $continueUrl
            spn: $spn
            clientMeta: $clientMeta
            source: $source
          ) {
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useApplyLinkQuery__
 *
 * To run a query within a React component, call `useApplyLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *      mobvjtk: // value for 'mobvjtk'
 *      continueUrl: // value for 'continueUrl'
 *      spn: // value for 'spn'
 *      clientMeta: // value for 'clientMeta'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useApplyLinkQuery(baseOptions: Apollo.QueryHookOptions<ApplyLinkQuery, ApplyLinkQueryVariables> & ({ variables: ApplyLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplyLinkQuery, ApplyLinkQueryVariables>(ApplyLinkDocument, options);
      }
export function useApplyLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplyLinkQuery, ApplyLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplyLinkQuery, ApplyLinkQueryVariables>(ApplyLinkDocument, options);
        }
export function useApplyLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplyLinkQuery, ApplyLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplyLinkQuery, ApplyLinkQueryVariables>(ApplyLinkDocument, options);
        }
export type ApplyLinkQueryHookResult = ReturnType<typeof useApplyLinkQuery>;
export type ApplyLinkLazyQueryHookResult = ReturnType<typeof useApplyLinkLazyQuery>;
export type ApplyLinkSuspenseQueryHookResult = ReturnType<typeof useApplyLinkSuspenseQuery>;
export type ApplyLinkQueryResult = Apollo.QueryResult<ApplyLinkQuery, ApplyLinkQueryVariables>;